import { RoutesService, eLayoutType } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/dashboard',
        name: '::Menu:Dashboard',
        iconClass: 'fas fa-chart-line',
        order: 3,
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Dashboard.Host  || ReturnLy.Dashboard.Tenant',
      },
      {
        path: '/reports',
        name: '::Menu:Reports',
        iconClass: 'fas fa-file-alt',
        order: 4,
        layout: eLayoutType.application,
        // Granted in the database, not seeded — the menu stays hidden until someone grants
        // ReturnLy.Reports to a role.
        requiredPolicy: 'ReturnLy.Reports',
      },
      {
        path: '',
        name: '::Menu:Configurations',
        iconClass: 'fas fa-sliders-h',
        order: 5,
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Cities || ReturnLy.Categories || ReturnLy.SubCategories || ReturnLy.Places || ReturnLy.BusinessTypes || ReturnLy.Addresses',
      },
      {
        path: '',
        name: '::Menu:UserManagement',
        iconClass: 'fas fa-user-friends',
        order: 4,
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Partners || ReturnLy.Admins',
      },
      {
        path: '/account/manage',
        name: '::PersonalProfile',
        iconClass: 'fas fa-user',
        order: 2,
        layout: eLayoutType.application,
      }
    ]);
  };
}
